export enum VitiStudimit {
  vitiPare = 'VITI_PARE',
  vitiDyte = 'VITI_DYTE',
  vitiTrete = 'VITI_TRETE',
  diplomuar = 'DIPLOMUAR',
}
